export default "__VITE_ASSET__DS48Jfl___"